import { isWeb } from '../environment';
import { ILocalComms } from './interfaces';
import LocalCommsImpl from './LocalComms';
import * as desktopStreams from './streams';

export const localComms: ILocalComms = new LocalCommsImpl();

// Default to desktop implementations. We'll dynamically load the RN SDK on
// mobile (via import()) and overwrite these exported bindings so consumers
// on native platforms pick up the RN implementations without using a
// top-level require or disabling eslint rules.
const desktopBase = desktopStreams.BaseEventEmitter;
const desktopSubscribe = desktopStreams.subscribeOrderEventsStream;
const desktopSubscribeAppEvents = desktopStreams.subscribeAppEventsStream;

export const BaseEventEmitter = desktopBase;
export const subscribeOrderEventsStream = desktopSubscribe;
export const subscribeAppEventsStream = desktopSubscribeAppEvents;

export function isLocalCommsEligible(): boolean {
  return localComms.isEnabled && !isWeb();
}
